// extracted by mini-css-extract-plugin
export default {"cookie":"cookie__v0WA0","choice":"choice__gvam3","cookiePopup":"cookiePopup__OBbiE","rocket":"rocket__4v0F-","closePopup":"closePopup__BRvDX"};